import { X } from "lucide-react";

export default function ArrayField({
  label,
  name,
  values,
  onChange,
  onRemove,
  onAdd,
}) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      {values.map((value, index) => (
        <div key={index} className="flex items-center mb-1">
          <input
            type="text"
            className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm flex-1 mb-0"
            value={value}
            onChange={(e) => onChange(name, index, e.target.value)}
          />
          <button
            onClick={() => onRemove(name, index)}
            className="ml-2 p-1 rounded hover:bg-gray-100"
          >
            <X className="text-red-400" />
          </button>
        </div>
      ))}
      <button
        onClick={() => onAdd(name)}
        className="text-blue-600 hover:text-blue-800 text-xs font-semibold cursor-pointer ml-1"
      >
        + 添加
      </button>
    </div>
  );
}
